import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-777adf5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mobile-icon",
  viewBox: "0 0 100 100",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0",
    y: "7.443",
    width: "100",
    height: "10.891"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0",
    y: "43.115",
    width: "50",
    height: "12.422"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0",
    y: "80.452",
    width: "79.053",
    height: "12.105"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import MainTitle from './MainTitle.vue';
import NavList from './NavList.vue';
import MobileNav from './MobileNav.vue';
import { onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBlock',
  setup(__props) {

const mobile = ref(false)
const showNav = ref(false)

onMounted(() => {
  setMediaQuery()
  window.addEventListener('resize', setMediaQuery);
})

onUnmounted(() => {
  window.removeEventListener('resize', setMediaQuery);
})

function setMediaQuery() {

  if (window.matchMedia("(max-width: 1100px)").matches) { // If media query matches
    mobile.value = true;
  } else {
    mobile.value = false;
}

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(MainTitle),
    (!mobile.value)
      ? (_openBlock(), _createBlock(NavList, { key: 0 }))
      : _createCommentVNode("", true),
    (mobile.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "nav-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNav.value = !showNav.value))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        ]))
      : _createCommentVNode("", true),
    (mobile.value && showNav.value)
      ? (_openBlock(), _createBlock(MobileNav, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})